var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import StepCompletedIcon from '../icons/StepCompletedIcon';
import StepInProgressIcon from '../icons/StepInProgressIcon';
import CloseIcon from '../icons/CloseIcon';
import useWidgetStore, { CurrentTabEnum } from '../../stores/widgetStore';
import useLatestPolicy from '../../hooks/useLatestPolicy';
var Steps = function (_a) {
    var theme = _a.theme, stepText = _a.stepText, isStepActive = _a.isStepActive, isStepCompleted = _a.isStepCompleted, stepIndex = _a.stepIndex;
    switch (theme) {
        case 'modern': {
            return (React.createElement("div", { className: "flex items-center justify-center gap-3 h-full py-4 pr-1 ".concat(isStepActive ? 'border-b-2 border-primary' : '') },
                React.createElement("div", { className: "".concat(isStepCompleted
                        ? 'bg-green-600'
                        : isStepActive
                            ? 'bg-primary text-white'
                            : 'bg-[#EEEEF0] text-[#808892]', " size-8 rounded-full flex items-center justify-center") }, isStepCompleted ? (React.createElement(FontAwesomeIcon, { icon: faCheck, className: "text-white" })) : (stepIndex + 1)),
                React.createElement("span", { className: "".concat(isStepActive ? 'font-semibold text-[#15161E]' : 'text-[#6A717D]', " block whitespace-nowrap text-xs md:text-xs lg:text-sm") }, stepText)));
        }
        default:
            return (React.createElement("div", { className: "flex flex-col items-center mr-2 gap-y-1 md:w-full md:min-w-max sm:flex-row sm:gap-x-1 max-w-fit" },
                isStepCompleted ? (React.createElement(StepCompletedIcon, null)) : (React.createElement(StepInProgressIcon, { active: isStepActive })),
                React.createElement("span", { className: "text-xs sm:text-xs md:text-xs lg:text-sm font-semibold whitespace-nowrap ".concat(isStepActive
                        ? 'text-primary'
                        : isStepCompleted
                            ? 'text-[#1F2751]'
                            : 'text-[#E9EDF7]') }, stepText)));
    }
};
var getThemeClasses = function (theme) {
    switch (theme) {
        case 'modern':
            return {
                mainContainer: 'border-b border-[#C5C9CF] px-4 sticky top-0 bg-white z-[200]',
                pageList: 'gap-12 justify-center h-full',
                showLines: false
            };
        default:
            return {
                mainContainer: 'border-b-2 border-[#F4F7FE] p-4 sticky top-0 bg-white z-[200]',
                pageList: 'max-w-[70%] items-center',
                showLines: true
            };
    }
};
var PolicyStepsHeader = function (_a) {
    var pageName = _a.pageName, theme = _a.theme, steps = _a.steps, nextButtonText = _a.nextButtonText, backButtonText = _a.backButtonText, handleNext = _a.handleNext, handleBack = _a.handleBack, _b = _a.hideNextButton, hideNextButton = _b === void 0 ? false : _b, _c = _a.isBackDisabled, isBackDisabled = _c === void 0 ? false : _c, _d = _a.isNextDisabled, isNextDisabled = _d === void 0 ? false : _d, _e = _a.isCloseDisabled, isCloseDisabled = _e === void 0 ? false : _e, _f = _a.hideSteps, hideSteps = _f === void 0 ? false : _f, _g = _a.shouldConfirm, shouldConfirm = _g === void 0 ? false : _g, _h = _a.buttonHidden, buttonHidden = _h === void 0 ? false : _h, handleClose = _a.handleClose;
    var _j = getThemeClasses(theme), mainContainer = _j.mainContainer, pageList = _j.pageList, showLines = _j.showLines;
    var latestPolicy = useLatestPolicy();
    var _k = useWidgetStore(), toggleModal = _k.toggleModal, setCurrentTab = _k.setCurrentTab;
    var handleFormClose = function () {
        var isConfirmed = shouldConfirm ||
            window.confirm('Are you sure you want to close the form?');
        if (isConfirmed) {
            if (handleClose) {
                handleClose();
            }
            else {
                if (latestPolicy) {
                    setCurrentTab(CurrentTabEnum.POLICY);
                }
                toggleModal();
            }
        }
    };
    return (React.createElement("div", { className: "flex flex-col items-center w-full ".concat(mainContainer, " gap-y-3 py-4") },
        React.createElement("div", { className: "w-full z-[100] flex items-center justify-between md:mt-0 mt-4" },
            React.createElement("div", { className: "flex items-center gap-x-2" },
                handleBack && (React.createElement("button", { type: "button", onClick: function () { return handleFormClose(); }, className: "rounded-full p-2 hover:bg-gray-100 focus:bg-gray-200", disabled: isCloseDisabled },
                    React.createElement(CloseIcon, null))),
                !buttonHidden && (React.createElement("button", { className: "px-4 sm:px-6 py-1.5 z-100 text-xs sm:text-xs md:text-sm text-[#707EAE] font-medium border-2 border-solid border-[#C8CEE3] rounded-lg disabled:opacity-40", type: "button", onClick: function () { return (handleBack ? handleBack() : handleFormClose()); }, disabled: isBackDisabled }, backButtonText ? backButtonText : 'Close'))),
            pageName && (React.createElement("span", { className: "text-lg sm:text-xl md:text-2xl font-bold text-[#1F2751] text-center ml-2 flex-1" }, pageName)),
            !pageName && (React.createElement("div", { className: "w-full ".concat(pageList, " hidden sm:flex flex-1") }, !hideSteps &&
                steps &&
                steps.length > 0 &&
                steps.map(function (step, index) {
                    return (React.createElement(React.Fragment, { key: index },
                        React.createElement(Steps, __assign({ theme: theme, stepIndex: index }, step)),
                        steps.length - 1 !== index && showLines && (React.createElement("div", { className: "w-full h-[1px] ".concat(step.isStepCompleted ? 'bg-primary' : 'bg-[#E9EDF7]') }))));
                }))),
            !hideNextButton ? (React.createElement("div", null,
                React.createElement("button", { className: "px-4 py-1.5 z-100 text-xs sm:text-xs md:text-sm text-white bg-[#FD515E] font-medium border-2 border-[#FD515E] rounded-lg disabled:bg-[#FBDFE0] disabled:text-[#EE7E82] disabled:border-[#FBDFE0]", onClick: function () { return handleNext && handleNext(); }, type: "submit", disabled: isNextDisabled }, nextButtonText ? nextButtonText : 'Continue'))) : (React.createElement("div", null))),
        React.createElement("div", { className: "w-full ".concat(hideNextButton && 'md:mt-10', " sm:hidden mb-4") }, !pageName && (React.createElement("div", { className: "flex items-center justify-center w-full" }, steps &&
            steps.length > 0 &&
            steps.map(function (step, index) {
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(Steps, __assign({ stepIndex: index }, step)),
                    steps.length - 1 !== index && (React.createElement("div", { className: "md:w-full h-[1px] mt-4 ".concat(step.isStepActive ? 'bg-primary' : 'bg-[#E9EDF7]') }))));
            }))))));
};
export default PolicyStepsHeader;
